module.exports = __webpack_public_path__ + "assets/56.jpg?98d56a7a91f08014fbde2deb96cf337e";